module.exports = __webpack_public_path__ + "images/terms-of-use-agreement-shake-hands-960w.jpg";